import { Route } from '../Routing/types';
import { DietSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';
import stepsSchemaPl from './stepsSchemaPl';
import stepsSchemaCz from './stepsSchemaCz';
import { DIET_TYPES_PL, DIET_TYPES_CZ, DIET_LEVELS } from '../GoalSettings/consts';

const dummy_t = (translationKey: string) => translationKey;

const activeLang = localStorage.getItem('i18nextLng');

const routes: Route[] = [
  {
    path: '/diet-settings/nutritionSettings/*',
    element: (
      <DietSettingsPage
        descendantRoutes={descendantRoutes}
        stepsSchema={activeLang === 'pl-PL' ? stepsSchemaPl : stepsSchemaCz}
        currentMainStep="nutritionSettings"
        dietTypes={activeLang === 'pl-PL' ? DIET_TYPES_PL : DIET_TYPES_CZ}
        dietLevels={activeLang === 'pl-PL' ? DIET_LEVELS : undefined}
      />
    ),
    private: true,
    title: dummy_t('nutritionSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
